import React from "react";
import MarketingLayout from "../../components/layout/marketing/MarketingLayout";
import HeroSection from "./sections/HeroSection";
import TestimonialsSection from "./sections/TestimonialsSection";
import FeaturesSection from "./sections/FeaturesSection";
import UsageSection from "./sections/UsageSection";
import PricingSection from "./sections/PricingSection";
import AIAgentSection from "./sections/AiAgentSection";
import FinalCTASection from "./sections/CTASection";

const Home = () => {
    return (
        <MarketingLayout>
            <HeroSection />
            <FeaturesSection />
            <TestimonialsSection />
            <UsageSection />
            <PricingSection />
            <AIAgentSection />
            <FinalCTASection />
        </MarketingLayout>
    );
};

export default Home;
